import React from 'react';
import { CalendarClockIcon, LayersIcon, MicIcon, PuzzleIcon } from 'lucide-react';
import { problems } from '../data/landingContent';
import { Container } from './Container';
import { Highlight, SectionHeading } from './SectionHeading';
const icons = {
  calendar: CalendarClockIcon,
  puzzle: PuzzleIcon,
  layers: LayersIcon,
  mic: MicIcon
};
export function ProblemsSection() {
  return <section className="bg-white py-14 sm:py-20 lg:py-28" data-id="element-117" data-mp="2sod2si9qwxcx">
      <Container data-id="element-118" data-mp="2sqz6u7xfguqe">
        <SectionHeading eyebrow="Sound familiar?" title={<>
              The lesson is tomorrow. <Highlight data-id="element-120" data-mp="2iri5g2p7l308">The plan isn’t ready.</Highlight>
            </>} data-id="element-119" data-mp="2xnzdajy6vzi1" />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-5" data-id="element-121" data-mp="2np9ver6amf1s">
          {problems.map(problem => {
          const Icon = icons[problem.icon as keyof typeof icons] ?? CalendarClockIcon;
          return <article key={problem.title} className="rounded-2xl border border-line bg-cream p-5 sm:p-8" data-id="element-122" data-mp="lx59bwbh6byz">
                <span className="grid h-11 w-11 place-items-center rounded-xl bg-teal-soft text-teal sm:h-12 sm:w-12" data-id="element-123" data-mp="1i4vikw45fezl">
                  <Icon aria-hidden="true" className="h-5 w-5 sm:h-6 sm:w-6" data-id="element-124" data-mp="1d595qns8g0rb" />
                </span>
                <h3 className="mt-4 font-condensed text-[23px] font-bold uppercase leading-[1.05] text-navy sm:mt-5 sm:text-[26px]" data-id="element-125" data-mp="1rycb7wsjuo1o">
                  {problem.title}
                </h3>
                <p className="mt-2 text-[14px] text-muted sm:mt-3 sm:text-[15px]" data-id="element-126" data-mp="z7ucf7yuz8u2">{problem.text}</p>
              </article>;
        })}
        </div>
        <p className="mx-auto mt-10 max-w-[620px] text-center font-condensed text-[25px] font-bold uppercase leading-tight text-navy sm:mt-12 sm:text-[32px]" data-id="element-127" data-mp="188iovy8lt14u">
          You don’t need more ideas. <Highlight data-id="element-128" data-mp="2jmw9mu8290gn">You need the lesson already put together.</Highlight>
        </p>
      </Container>
    </section>;
}